import { render, staticRenderFns } from "./CustomVariance.vue?vue&type=template&id=47958ce8&scoped=true&"
import script from "./CustomVariance.vue?vue&type=script&lang=js&"
export * from "./CustomVariance.vue?vue&type=script&lang=js&"
import style0 from "./CustomVariance.vue?vue&type=style&index=0&id=47958ce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47958ce8",
  null
  
)

export default component.exports